/* New HubSpot forms */
/*
window.addEventListener('hs-form-event:on-submission:success', (event) => {
  const formId = event.formId || event.target?.id || event.detail?.id;
  const submission = event.detail?.submissionValues || {};

  if (formId) {
    Shopify.analytics.publish('lead', {
      formId,
      ...submission
    });;
  }
});
*/

// Legacy HubSpot forms
window.addEventListener('message', ({ data }) => {
  if (
    data.type === 'hsFormCallback' &&
    data.eventName === 'onFormSubmitted'
  ) {
    Shopify.analytics.publish('lead', {
      formId: data.data.formGuid,
      ...data.data.submissionValues
    });
  }
});

// HubSpot CTAs
window.addEventListener('message', ({ data }) => {
  if (
    data.type === 'hsCallsToActionCallback' &&
    data.eventName === 'onCallToActionFormSubmitted'
  ) {
    Shopify.analytics.publish('lead', {
      formId: data.data.formId,
      ctaId: data.data.id,
      ...data.data.submissionValues
    });
  }
});


/* Some events are only needed in Google Analytics, so are sent diretly */

// function isStaff() {
//   return document.cookie.includes('internal_staff_flag=1');
// }

// Accordions
// function track_accordion_toggle(label, nowOpen) {
//   sendGA4Event('dropdown_toggle', {
//     'action': nowOpen ? 'open' : 'close',
//     'label':  label
//   })
// }

// Track opening accordions.
window.addEventListener('DOMContentLoaded', function() {
  // if(isStaff()) {
  //   console.log('Staff traffic blocked');
  //   return;
  // }
  // Tag the items in the cart (except the bike details)
  // document.querySelectorAll('.accordion-trigger').forEach((accordion) => {
  //   accordion.addEventListener('click', function(event) {
  //     let nowOpen = accordion.classList.contains('open');
  //     // Exclude the bike details accordion.
  //     if (accordion.closest('.cart__meta')) {
  //       return;
  //     }
  //     track_accordion_toggle(accordion.innerText, nowOpen);
  //   });
  // });
  // Tag new style accordions with <details>
  // document.querySelectorAll('collapsible-content details').forEach((details) => {
  //   details.addEventListener('toggle', function(event) {
  //     let item = event.target?.querySelector('summary');
  //     if (item) {
  //       let nowOpen = event.newState == 'open';
  //       track_accordion_toggle(item.innerText, nowOpen);
  //     }
  //   })
  // })
  // Generic tracker — add data-track-event, data-track-action, data-track-label to any element.
  // document.querySelectorAll('[data-track-event]').forEach(function(el) {
  //   el.addEventListener('click', function() {
  //     const params = {};

  //     if (el.dataset.trackAction) params.action = el.dataset.trackAction;
  //     if (el.dataset.trackLabel) params.label = el.dataset.trackLabel;

  //     if (el.dataset.trackParams) {
  //       Object.assign(params, JSON.parse(el.dataset.trackParams));
  //     }

  //     sendGA4Event(el.dataset.trackEvent, params);
  //   });
  // });
})
